import React from "react";
import { HeuristicBlock, isNum } from "./paeiPrimitives";

// What the redesign did, in the order it did it. One block per applied heuristic.
function PaeiRedesignTab({ result }) {
  const redesign = result?.redesign || {};
  const available = redesign.available !== false;
  const heuristics = redesign.heuristics || [];
  const replayMatches = redesign.replay_check ? redesign.replay_check.matches !== false : true;

  if (!available) {
    return (
      <div className="pa-panel">
        <div className="pa-banner warn">
          <strong>The redesign did not run.</strong>{" "}
          {redesign.reason || "No reason was supplied by the agent."}
        </div>
        {redesign.note && <p className="pa-note">{redesign.note}</p>}
      </div>
    );
  }

  return (
    <div className="pa-panel">
      {!replayMatches && (
        <div className="pa-banner danger">
          <strong>Replay check failed.</strong> Re-applying the listed heuristics did not reproduce
          the TO-BE the figures were computed on. The numbers above describe a slightly different
          process than the one described here — treat both as indicative until this is resolved.
        </div>
      )}

      <div className="pa-summary-strip">
        <span>
          <b>{heuristics.length}</b> heuristic{heuristics.length === 1 ? "" : "s"} applied
        </span>
        {isNum(redesign.time_improvement_pct) && (
          <span className={Number(redesign.time_improvement_pct) > 0 ? "saving" : ""}>
            Time <b>{Number(redesign.time_improvement_pct).toFixed(1)}%</b>
          </span>
        )}
        {isNum(redesign.cost_improvement_pct) && (
          <span className={Number(redesign.cost_improvement_pct) > 0 ? "saving" : ""}>
            Cost <b>{Number(redesign.cost_improvement_pct).toFixed(1)}%</b>
          </span>
        )}
      </div>

      {redesign.note && <p className="pa-card-hint">{redesign.note}</p>}

      {heuristics.length === 0 ? (
        <div className="pa-empty">
          The redesign ran but applied no heuristic — the process as declared already sits outside
          every shift's trigger conditions.
        </div>
      ) : (
        <div className="pa-heuristic-list">
          {heuristics.map((h, i) => (
            <HeuristicBlock key={`${h.heuristic}-${i}`} item={h} applied />
          ))}
        </div>
      )}

      <p className="pa-note">
        Each heuristic trades something away. The <b>delta chips</b> say which capability the step
        stops needing and which it starts needing — they are a shift in demand, not a saving.
      </p>
    </div>
  );
}

export default PaeiRedesignTab;
